import {Link, List, ListItem, Sheet, Stack, Typography} from "@mui/joy";
import React, {useContext} from "react";
import './Drawer.css';
import SocialNetwork from "./SocialNetwork";
import {DrawerContext, DrawerType} from "../context/DrawerContext";
import Divider from "@mui/joy/Divider";
import ContactInfo from "./ContactInfo";
import {SummaryModel} from "../model/summary";
export function MyDrawer({summary} : {summary: SummaryModel}) {
    const {isOpen, handlerClose} = useContext<DrawerType>(DrawerContext);
    const classNames = 'drawer' + (isOpen ? ' open' : '') ;
    return (
        <Sheet variant='soft' className={classNames} onClick={()=>{handlerClose()}}>
            <Stack paddingTop={1}  direction='column' spacing={2}>
                <Stack width='100%' direction='row'>
                    <Stack flexGrow={1}/>
                    {/*<IconButton onClick={()=>{handlerClose()}}>
                        <CloseRounded/>
                    </IconButton>*/}
                </Stack>
                <List orientation='vertical' sx={{
                    "--ListItem-paddingX": "0px",
                    "--ListDivider-gap": "0px",
                    "--List-gap": "0px",
                    justifyContent: "flex-start"
                }}
                >
                    <ListItem key='home'>
                        <Link href="/" variant="plain" underline="none">Home</Link>
                    </ListItem>
                    <Divider/>
                    <ListItem key='works'>
                        <Link href="/works" variant="plain" underline="none">Work</Link>
                    </ListItem>
                    <ListItem key='bio'>
                        <Link href="/bio" variant="plain" underline="none">Bio</Link>
                    </ListItem>
                    <Divider/>
                    <ListItem key='contact'>
                        <Link href="/contact" variant="plain" underline="none">Contact</Link>
                    </ListItem>
                    <Divider/>
                </List>
                <Stack minHeight={100} flexGrow={1}/>
                <Typography level='body-sm'>Follow Us</Typography>
                <SocialNetwork summary={summary}/>
                <Divider/>
                <ContactInfo summary={summary}/>

            </Stack>
        </Sheet>
    )
        ;
}